import { Injectable } from '@angular/core';
import { createEffect } from '@ngrx/effects';
import { UsageSnapshotService } from './usage-snapshot.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of, timer } from 'rxjs';
import { UsageSnapshotActions } from './usage-snapshot.actions';

@Injectable()
export class UsageSnapshotEffects {
  private readonly FIVE_MINUTES = 5 * 60 * 1000;

  pollOrganizationMonthlyUsageSnapshot$ = createEffect(() =>
    timer(0, this.FIVE_MINUTES).pipe(
      switchMap(() =>
        this.usageSnapshotService.getOrganizationMonthlyUsageSnapshot().pipe(
          map((snapshot) => UsageSnapshotActions.getUsageSnapshotSucceeded({ snapshot })),
          catchError((error) => of(UsageSnapshotActions.getUsageSnapshotErrored({ error }))),
        ),
      ),
    ),
  );

  constructor(private usageSnapshotService: UsageSnapshotService) {}
}
